import { Button, Stack, Typography } from "@mui/material";
import type { ReservationState } from "../../util/useReservationState";

export default function FormError({ state }: { state: ReservationState }) {
  return (
    <Stack gap={1} mt={2}>
      <Typography textAlign="center">エラーが発生しました。最初からやり直してください。</Typography>
      <Button onClick={state.reset} variant="outlined">
        トップへ
      </Button>
    </Stack>
  );
}
